import qs from 'qs';
import axiosAPI from '@/axios';

function getLive(channelId) {
  return axiosAPI.get(`channels/${channelId}/live`);
}

function getPreviews(channelId, start, end) {
  return axiosAPI.get(`channels/${channelId}/previews`, {
    params: {
      startedAt: start,
      endedAt: end,
    },
  });
}

function createChannel(payload) {
  return axiosAPI.post('/channels', payload);
}

function loadChannels() {
  return axiosAPI.get('/channels');
}

function loadChannelById(channelId) {
  return axiosAPI.get(`channels/${channelId}`);
}

function downloadClip(payload) {
  return axiosAPI.post('/clips', payload);
}

function downloadClipById(clip) {
  return axiosAPI.get(`/clips/${clip._id}/files/video.mp4`);
}

function loadClips(queryParams) {
  if (queryParams) {
    const query = qs.stringify(queryParams, { addQueryPrefix: true, skipNulls: true });
    return axiosAPI.get(`/clips/mine${query}`);
  }
  return axiosAPI.get('/clips/mine');
}

function loadMonthlyClips(year, month) {
  return axiosAPI.get(`/clips/monthly/${year}/${month}`);
}

function loadAllClips(queryParams) {
  if (queryParams) {
    const query = qs.stringify(queryParams, { addQueryPrefix: true, skipNulls: true });
    return axiosAPI.get(`/clips${query}`);
  }
  return axiosAPI.get('/clips');
}

export {
  getLive,
  getPreviews,
  loadClips,
  loadMonthlyClips,
  loadAllClips,
  createChannel,
  loadChannels,
  loadChannelById,
  downloadClip,
  downloadClipById,
};
